import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 75,
  },
  between: {
    display: "flex",
    justifyContent: "space-between",
    margin: 10,
    alignItems: "center",
  },
  between2: {
    display: "flex",
    justifyContent: "space-between",
    margin: 20,
    alignItems: "center",
  },
  between3: {
    display: "flex",
    justifyContent: "space-between",
    margin: 10,
    alignItems: "center",
  },
  liquidSmallGrey: {
    fontSize: 12.3,
    color: "grey",
    textTransform: "capitalize",
  },
  liquidBold: {
    fontSize: 14,
    textTransform: "capitalize",
    fontWeight: "bold",
  },
  liquid: {
    fontSize: 13,
    textTransform: "capitalize",
  },
  liquidGrey: {
    fontSize: 14,
    textTransform: "capitalize",
    color: "grey",
    fontWeight: "bold",
  },
}));

export default useStyles;
